import { Box, Button, Image, Text } from '@mantine/core'

import { CryptoBasketCoin, InvestCardType } from '@/types/invest'

import BasketCard from '../../_components/Invest/BasketCard'
import Earn from './_assets/earn.webp'
import Exchange from './_assets/exchange.webp'
import Recurring from './_assets/recurring.webp'
import Stake from './_assets/stake.webp'
import styles from './styles.module.css'

interface InvestCardProps {
  type: InvestCardType
  title: string
  link: string
  image?: string
  updatePercentage?: string
  updateTime?: string
  tagIcons?: CryptoBasketCoin[]
  buttonText?: string // Make optional
  onButtonClick?: () => void
  badge?: string
}

export default function InvestCard({
  type,
  title,
  image,
  updatePercentage,
  updateTime,
  tagIcons = [],
  buttonText,
  onButtonClick,
  badge,
  link,
}: InvestCardProps) {
  function getCardImage() {
    if (type === InvestCardType.Exchange) {
      return Exchange
    }
    if (type === InvestCardType.Earn) {
      return Earn
    }
    if (type === InvestCardType.Stake) {
      return Stake
    }
    if (type === InvestCardType.Recurring) {
      return Recurring
    }
    return Exchange
  }

  const cardImage = getCardImage()
  // type === InvestCardType.Earn ? Earn : type === InvestCardType.Stake ? Stake : Recurring

  if (type === InvestCardType.Basket) {
    return (
      <BasketCard
        type={type}
        title={title}
        image={image}
        updateTime={updateTime}
        tagIcons={tagIcons}
        updatePercentage={updatePercentage}
        badge={badge}
        link={link}
      />
    )
  }

  return (
    <Box className={styles.cardContainer} onClick={() => window.open(link, '_blank')}>
      {/* Image */}
      <Box className={styles.imageContainer}>
        <Image src={cardImage.src} height="100%" alt={title} />
      </Box>

      {/* Content */}
      <Box className={styles.contentContainer}>
        <Text variant={'body-emphasis'}>{title}</Text>

        <Button className={styles.actionButton} onClick={onButtonClick}>
          <Text variant="subtitle-emphasis" c="var(--content-active-bold)">
            {buttonText}
          </Text>
        </Button>
      </Box>
    </Box>
  )
}
